
















import {
  computed,
  defineComponent,
  reactive,
  watch,
} from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import expenseByPaymentAccount from '@/gql/managementReport/02-Expense/expenseByPaymentAccount.gql';

import HorizontalStackedChart from '@/components/Vivat/Chart/HorizontalStackedChart.vue';

import {
  NOW_START_MONTH,
  NOW_END_MONTH,
} from '@/utils';
import {
  deliveryTimeColor,
} from '@/useDelivery';
import { normalize } from 'path';
import LeasedVehicleObject from '@/components/DeliveryNote/LeasedVehicleObject.vue';

interface PaymentAccount { paymentAccount: string; amount: number }
const HorizonStackByPayment = defineComponent({
  components: {
    HorizontalStackedChart,
  },
  props: {
    height: {},
    title: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const filter = reactive({
      hub: null,
      monthRange: {
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      },
      deliveryType: undefined,
    });

    const { result, loading } = useQuery(expenseByPaymentAccount, computed(() => ({
      timeframe: filter.monthRange,
      deliveryTypeNormal: 'NORMAL',
      deliveryTypeLeased: 'LEASED',
    })));
    const getDataArray = computed(() => result?.value?.expenseLeased || []);

    const chartData = computed(() => {
      const labelsNormal: string[] = [];
      const labelsLeased: string[] = [];
      const amountNormal: number[] = [];
      const amountLeased: number[] = [];
      (result?.value?.expenseByPaymentAccount || []).forEach((item: PaymentAccount, index: number) => {
        labelsNormal.push(item.paymentAccount);
        amountNormal.push(item.amount);
      });
      (result?.value?.expenseLeased || []).forEach((item: PaymentAccount, index: number) => {
        if (labelsNormal.indexOf(item.paymentAccount)) {
          labelsLeased[labelsNormal.indexOf(item.paymentAccount)] = item.paymentAccount;
          amountLeased[labelsNormal.indexOf(item.paymentAccount)] = item.amount;
        }
        labelsLeased.push(labelsNormal[index]);
        amountLeased.push(0);
      });

      return {
        labels: [...labelsNormal],
        datasets: [
          {
            label: 'FTL',
            data: [...amountNormal],
            backgroundColor: '#8E060F',
            stack: 'STACK',
          },
          {
            label: 'LTL',
            data: [...amountLeased],
            backgroundColor: '#F33131',
            stack: 'STACK',
          },
        ],
      };
    });
    return {
      filter,
      chartData,
    };
  },
});

export default HorizonStackByPayment;
